import { Pipe, PipeTransform } from '@angular/core';
import { CommonService } from '../Services/common.service';
import { DatePipe } from '@angular/common';
import { isObjectEmpty } from 'ngx-bootstrap/chronos/utils/type-checks';
// import { isObjectArray } from '@progress/kendo-angular-dropdowns/dist/es2015/util';
import { isObject } from 'util';

@Pipe({
  name: 'dateformat'
})
export class DateformatPipe implements PipeTransform {

  dateFormat: any;
  constructor(private _CommonService: CommonService, private datepipe: DatePipe) {

  }
  transform(value: any, args?: any): any {
    // debugger;
    let date1 = value
    // if (value != "") {

    //   if (typeof value == "object") {
    //     value = JSON.stringify(value);
    //     if (value == "{}") value = "";
    //   }
    // }
    let date = value;
    if (!this._CommonService.isNullOrEmptyString(date)) {
      return this._CommonService.getFormatDateGlobal(date);
    }

  }
}
